define('views/components/cd_role/cd_role_list',['require','views/base/list_view','views/components/cd_role/cd_role','text!templates/components/cd_role/cd_role_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/cd_role/cd_role');

    var temp = require("text!templates/components/cd_role/cd_role_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

